/* eslint-disable angular/constant-name */
angular.module("dx.webapp.wordGap").constant("DX_WORD_GAP_MODE",
	Object.freeze({
		STATIC: "static",
	})
);
